export const MapSettings = {
  container: 'map',
  // style: 'mapbox://styles/mapbox/light-v10',
  // style: 'mapbox://styles/mapbox/dark-v10',
  // style: 'mapbox://styles/aethernillier/ck7k0wja31b291iqtchaxe4ix',
  style: 'mapbox://styles/mapbox/streets-v11',
  // style: 'mapbox://styles/dnlsalazar/ckfu6q4510yqx1at04lebyhkh',
  zoom: 6,
  minZoom: 0,
  maxZoom: 0,
  center: [76.734136, 30.683601],
  maxPitch: 60,
  pitch: 0,
  bearing: 0,
}

export const SourceForMap = () => {
  return {
    'type': 'geojson',
    'data': {}
  };
};

export const dataForSource = () => {
  return {
    'type': 'FeatureCollection',
    'features': []
  };
}

export const DataFeature = (long, lat, address, secondLine, imageUrl,rotateA, PageLink) => {
  const coors = [long ? long : 0, lat ? lat : 0];
  return {
    'type': 'Feature',
    'geometry': {
      'type': 'Point',
      'coordinates': coors,
    },
    'properties': { description: address, secondLine: secondLine, imageUrl: imageUrl, rotateA:rotateA,PageLink: PageLink }
  };
};

export const demoFeatures = [
  {
    "type": "Feature",
    "properties": {
      "businessID": "FNfcTGzj4JetidZRnDpzAjNrzuN2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.2084235923401,
        7.806414448778995
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "cRQM4ohAVtfC2RGfxyFpxh9H2723"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.21230604107137,
        7.791407334950449
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "9ajL5gi1ymOw7I69y89NjguQX562"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        0,
        0
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "mXL0Y5vmfBTOip1eSvw2npiIlQP2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.20553447965234,
        7.763296280942299
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "a3DiUPBDWZfMLwEsq983V0oKKD43"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.2350591,
        7.756104
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "Z74Bz2uM8aXD0ZSTFKdyfbZ7oom1"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.20942732564296,
        7.765007250625203
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "LwgqhFvrksbjs4BJOi299FQDkyg1"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22062609236238,
        7.7713772055354156
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "h53cebU5OJc8n9Fwxf4Rx9qtrgw2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.21217008976107,
        7.768735294855631
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "4FiTTVkk7yYGJasjuHEMKBhKi0I3"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        "",
        ""
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "BiDnqTPh24XDYNHjUjYWdK4wk5T2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.21895121885386,
        7.783026101178464
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "OGTiWkCaILdRYOh9q7gVdY9BtrD3"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.2422408448975,
        7.8370971936944755
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "p3d68uPCqRZhMDFi5KQFEqhnOEL2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.20375584858984,
        7.783300699570219
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "2Ol7XjEuSkTo1yclRSQ6wHJDOkG2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.219466,
        7.76832
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "t23S2g3rACQKNUNBHoDRSCOYtlp1"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.2337334660082,
        7.768172053460816
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "6VPXjuZCwtWC7zBMGGOarxWsMO23"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.2192998627738,
        7.798669661701027
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "00Dd5sYDRJO9HSWRBeIXznTEOQY2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -69.38961030681213,
        10.066253424198251
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "LwMRjkfQxqWiVE2zK87jxqF0vGA2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -68.00357441762856,
        10.182029389492385
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "61P90hX8eUVXkKSH01ifglOfRLI2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -66.91367161291865,
        10.507756038690161
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "6vRgaGrlYWakcHsqw7qWqNHheX43"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.21977016807266,
        7.795412147036004
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "3S2AABPCK8WNBVw5G521hKIOIMn2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.21903937320879,
        7.771990017339093
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "UOHioQEHLZYn49m8aUP1GgIkVpA3"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.2219908091601,
        7.78954031734483
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "ucSwQjIxkvZG4F6PYOJt3ZiLytB2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.2197790647576,
        7.767375813485842
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "EiVtHzXwXuSDOQZIx1ZTpYRUxTA3"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.2183186591513,
        7.770404866827519
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "33jNZWyBRUMKyoPdyxYg3FFDUEr2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22714215716051,
        7.774987874811103
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "YoetzBWeXHNLFyxFitBCDzqaRy62"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.24116123291091,
        7.777390268722812
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "AUijGSCkepSLSueZIsHii0bANaO2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.2236517724615,
        7.765824511700316
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "aiGeWRlgz2gK5AzdbC2Eq5FYcQ43"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22033234380734,
        7.798273017850178
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "C8gbPJluMWNKYbOP9if4KChhL672"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.21640066010464,
        7.768387954543016
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "vd6oA0ALi0Srm2lcWTC8slzsmEO2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22135721847204,
        7.748430211925822
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "uK6DhEzrcsdOFYMfy45XgOJDQAH3"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22115443495338,
        7.823777082696367
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "BfJ2NPjn4DU3tV78lybbCltbjvD3"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.2272368861691,
        7.831104027180629
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "IA8NOS1pZKcdwWAWkpyDc7XajqV2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.20577277330729,
        7.75917991867037
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "fXQXiNeKhMcbeFZGG4yyzEwtwk32"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.20637381260035,
        7.758030912723925
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "NaMFrNW6h4Wl2pHaG37LpTPNxAm1"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.14968455618293,
        7.755630215401837
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "k9Xx6pJrDAcVP8duuZ0qIBSFuVs2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.219038960544,
        7.770314815759519
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "ShQi08EbYcd3Svno5qVV4CmbULt1"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22921390691977,
        7.760067680414764
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "HsUkr7qvZ9V4A2UUJ3tfV63RXzA2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -69.28640496308257,
        10.07986759033507
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "onnQ6GZktESuOGPUBoMANnTh4sX2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22477990694571,
        7.771971645068135
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "K6nMzSq3IQaUHraeMmJ6S3QRcMR2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22013300090056,
        7.770015688313208
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "2Wxs8j18bkQ8z93xmPLiqsyeLn32"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.23223057758871,
        7.766791740288255
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "MVeNPw4YtffNCcAsme2Hdw1Z18e2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22189419632468,
        7.775016782066601
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "ml6q7t6b2QRd1G68cn4YsqDHM2C2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.23480101037839,
        7.741130793556977
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "pwJO6ZkoQeX9W6csam9ItzEnSiy2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.20673102658043,
        7.768400546175755
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "RzAo73ON1qYnBLgYGCO9WvZA6Ih1"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.216308731622,
        7.782011185669987
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "CxSA5OaQSnhHezLyXfy7UNSKUEE2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -66.96468809998565,
        10.505434895994824
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "2PH06hbAulPMUd6L6yrxmDHH0Gl1"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22295552227024,
        7.766771963891983
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "mWVdPwQOKHVIi8UpV58fKWeh8Mo2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.21868351489634,
        7.752530421472258
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "GCXFRr7s5Ec9D3SXCeDBBXlvPy83"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.21316435664963,
        7.758573418146881
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "hgzh9vrKSBYkShq6gDjXjcDhpMF3"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22205642303145,
        7.781516362178763
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "jjR2x3ny31geNoCErup652GTOGT2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.22320144439074,
        7.768451887873681
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "NBcvyvP0DPV92cR3YE2UW4etdLU2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.21090472160888,
        7.774801062725274
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "businessID": "ki4DskFnDZQ97N5bR0NVKXSmAku2"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -72.23244363015772,
        7.774394975053255
      ]
    }
  }
];